import React, { useState } from 'react'
import { getRoute, Sites } from '@pmi/pmi-iqos-shared-react'
import { ProductCardGeneric } from '@zyn-common/components'

const CardBundle = ({
  bundle,
  translations,
  loading,
  noDetailLink,
  onAddToCart,
  bundleDetailPath,
  ...rest
}) => {
  const [isAddingToCart, setIsAddingToCart] = useState(false)

  const handleAddToCart = async () => {
    setIsAddingToCart(true)
    onAddToCart && (await onAddToCart(bundle))
    setIsAddingToCart(false)
  }

  const { id, image, name, description, price, currency, badge, listPrice } =
    bundle

  return (
    <ProductCardGeneric
      handleAddToCart={handleAddToCart}
      id={id}
      images={[image]}
      title={name}
      description={description}
      alternativeBadge={badge}
      price={price}
      listPrice={listPrice}
      currency={currency}
      translations={translations}
      loading={isAddingToCart || loading}
      stock
      href={
        noDetailLink || !bundleDetailPath
          ? null
          : bundle.specialPath
          ? bundle.specialPath
          : getRoute(bundleDetailPath + id, true, false, null, null, Sites.zyn)
      }
      testingPrefix="ProductBundleList"
      {...rest}
    />
  )
}

export default CardBundle
